import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgShine13 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M6 3.001v3M3 6h3m0 3v-3m3 0H6'
    />
    <path
      fill='#fff'
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M6 13.5c4.142-1 6.5-3.358 7.5-7.5 1 4.142 3.358 6.5 7.5 7.5-4.142 1-6.5 3.358-7.5 7.5-1-4.142-3.358-6.5-7.5-7.5'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgShine13)
export default ForwardRef
